import React, { useState } from 'react';
import { Col, Row, Select, DatePicker, Button, Radio, Form } from 'antd';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { getWithExpiry } from '../../utils/localStorage';
import { LocalStorageKeys } from '../../utils/constant';
import _ from 'lodash';
import useTime from '../../hooks/useTime';

const { Option } = Select;
const { RangePicker } = DatePicker;

const SearchBusOrder = (props) => {
  const storage = getWithExpiry(LocalStorageKeys.order_list);
  const [form] = Form.useForm();
  const { formatAsISOString } = useTime();

  const { data, onFilter, setFilter, justify, colTextSearch, filter } = props;
  const intl = useIntl();
  const [value, setValue] = useState('depart');

  const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };

  const createData = (data) => {
    if (data.length) {
      const defaultOption = {
        name: 'name',
        col: 4,
        placeholder: 'Select',
        data: [],
        type: 'multiple',
      };
      return data.map((item) => {
        if (storage?.filter?.filter_name && storage?.filter?.filter_value) {
          const filter_name = storage?.filter?.filter_name;
          const filter_value = storage?.filter?.filter_value;
          if (Array.isArray(filter_name) && Array.isArray(filter_value)) {
            if (item?.name) {
              const index = _.findIndex(
                filter_name,
                (name) => name === item.name,
              );
              if (index !== -1) {
                item['defaultValue'] = filter_value[index];
              }
            }
          }
        }

        return {
          ...defaultOption,
          ...item,
          onChange: (value) => onFilter(value, item.name, ''),
        };
      });
    }
    return [];
  };

  const createElement = (data) => {
    var dataElement = createData(data);

    if (dataElement?.length) {
      return dataElement?.map((item, index) => {
        return item.data[0]?.id ? (
          <Col sm={{ span: 4 }} xs={{ span: 24 }} key={index}>
            <Form.Item name={item.name}>
              <Select
                // mode={item.type}
                showSearch
                placeholder={item?.placeholder}
                onChange={item?.onChange}
                style={{ width: '100%' }}
                allowClear={true}
                optionFilterProp="children"
                filterOption={(input, option) => {
                  if (typeof option.children !== 'string') {
                    if (option?.children?.props?.id) {
                      return (
                        intl
                          .formatMessage({ id: option?.children?.props?.id })
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    } else {
                      return (
                        option.value
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    }
                  }
                  return (
                    option?.children
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  );
                }}
                defaultValue={item?.defaultValue}>
                {item?.data?.length &&
                  item?.data?.map((option, i) => {
                    return (
                      <Option key={i} value={option?.id ? option?.id : ''}>
                        {option?.title || option?.display}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
        ) : (
          <Col sm={{ span: 4 }} xs={{ span: 24 }} key={index}>
            <Form.Item name={item.name}>
              <Select
                showSearch
                placeholder={item?.placeholder}
                onChange={item?.onChange}
                style={{ width: '100%' }}
                allowClear={true}
                optionFilterProp="children"
                filterOption={(input, option) => {
                  if (typeof option.children !== 'string') {
                    if (option?.children?.props?.id) {
                      return (
                        intl
                          .formatMessage({ id: option?.children?.props?.id })
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    } else {
                      return (
                        option.value
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    }
                  }
                  return (
                    option?.children
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  );
                }}
                defaultValue={item?.defaultValue}>
                {item?.data?.length &&
                  item?.data?.map((option, i) => {
                    return (
                      <Option
                        key={i}
                        value={option?.value ? option?.value : ''}>
                        {option?.label || option?.title || option?.display}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
        );
      });
    }
    return null;
  };

  const onChangeSearch = (e) => {
    form.resetFields();
    setValue(e.target.value);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        let filter_name = [];
        let filter_value = [];
        let from_date = null;
        let to_date = null;
        if (values?.range_picker) {
          from_date = JSON.stringify(
            formatAsISOString(values?.range_picker[0]),
          );
          to_date = JSON.stringify(formatAsISOString(values?.range_picker[1]));
        }

        for (const [key, value] of Object.entries(
          _.omitBy(_.omit(values, ['range_picker']), _.isUndefined),
        )) {
          filter_name.push(key);
          filter_value.push(value);
        }

        const filterUpdate = {};
        if (value === 'depart') {
          filterUpdate.from_date = from_date;
          filterUpdate.to_date = to_date;
        } else if (value === 'created') {
          filterUpdate.from_created_at = from_date;
          filterUpdate.to_created_at = to_date;
        }

        delete data.range_picker;
        setFilter((filter) => {
          return {
            ...filter,
            filter_name: filter_name,
            filter_value: filter_value,
            ...filterUpdate,
          };
        });
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <Radio.Group onChange={onChangeSearch} value={value}>
        <Radio value={'depart'}>Voyage</Radio>
        <Radio value={'created'}>Réservation</Radio>
      </Radio.Group>
      <Form
        {...layout}
        form={form}
        onFinish={handleOk}
        name="control-hooks"
        style={{ maxWidth: 1000 }}>
        <Row type="flex" gutter={[16, 16]} justify={justify}>
          <Col sm={{ span: colTextSearch }} xs={{ span: 24 }}>
            <Form.Item name="range_picker">
              <RangePicker
                placeholder={['Date', 'Date']}
                format={'DD-MM-YYYY'}
                style={{ width: '100%' }}
                // onChange={handleRangeChange}
              />
            </Form.Item>
          </Col>
          {createElement(data)}
          <Button
            htmlType="submit"
            style={{ background: '#14bb8c', color: '#FFF', cursor: 'pointer' }}>
            Chercher
          </Button>
        </Row>
      </Form>
    </>
  );
};

SearchBusOrder.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  textSearch: PropTypes.bool,
  onFilter: PropTypes.func,
  searchOption: PropTypes.object,
  justify: PropTypes.oneOf(['start', 'end', 'center', 'space-between']),
  showActionBar: PropTypes.bool,
  colTextSearch: PropTypes.number,
};

SearchBusOrder.defaultProps = {
  data: [],
  onFilter: () => {},
  textSearch: true,
  searchOption: {},
  justify: 'start',
  showActionBar: true,
  colTextSearch: 6,
};

export default SearchBusOrder;
